// Calculate medical status for a single user
export const calculateUserMedicalStatus = ({
  user_collections,
  is_pathology_done,
  is_physical_done,
  is_radiology_done,
  status,
}) => {
  // Get unique investigation group IDs
  const uniqueGroupIds = new Set(
    user_collections
      ?.map((c) => c.investigation_category?.investigation_group_id)
      .filter((id) => id !== 4)
  );
  const groupCount = uniqueGroupIds.size;

  // Calculate completed tests count
  const completedTests =
    (is_pathology_done ? 1 : 0) +
    (is_physical_done ? 1 : 0) +
    (is_radiology_done ? 1 : 0);

  // Determine if all required tests are done
  const isDone =
    groupCount < 2
      ? completedTests < 2
      : groupCount < 3
      ? completedTests >= 2
      : completedTests === 3;

  return {
    isDone,
    status,
  };
};

// Calculate medical status counts for all users
export const calculateMedicalStatusCounts = (data = []) => {
  const counts = {
    fit: 0,
    unfit: 0,
    heldUp: 0,
    others: 0,
    total: data.length,
  };

  data.forEach((user) => {
    const { isDone, status } = calculateUserMedicalStatus(user);

    if (!isDone || status === 1) {
      counts.others++;
    } else {
      switch (status) {
        case 2:
          counts.fit++;
          break;
        case 3:
          counts.unfit++;
          break;
        case 4:
          counts.heldUp++;
          break;
        default:
          break;
      }
    }
  });

  return counts;
};
